import {
  fontWeightVars,
  smallTextPreset,
  spacingVars,
} from '@tundr/ds-foundations';
import { style } from '@vanilla-extract/css';

export const dropdownTitleClass = style({
  ...smallTextPreset,
  fontWeight: fontWeightVars.semiBold,
  padding: `${spacingVars.sm} ${spacingVars.sm} 0 ${spacingVars.sm}`,
});

export const tooltipAnchorClass = style({
  display: 'inline-flex',
});

export const columnListClass = style({
  width: '100%',
  padding: 0,
});
